import { useEffect, useMemo } from "react";
import {
  UseFormClearErrors,
  UseFormGetValues,
  UseFormTrigger,
} from "react-hook-form";
import { ObjectShape } from "yup";

import { hasKeys, IExtendableDto, iterateFormFields } from "@ryde/shared";

interface IUseConditionalFormRevalidate {
  yupSchemaDynamic: ObjectShape;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  trigger: UseFormTrigger<any>;
  isEdit: boolean | undefined;
  dto: IExtendableDto | undefined;
  getValues: UseFormGetValues<IExtendableDto>;
  clearErrors?: UseFormClearErrors<IExtendableDto>;
}

export const useConditionalFormRevalidate = ({
  yupSchemaDynamic,
  trigger,
  getValues,
  clearErrors,
  isEdit,
  dto,
}: IUseConditionalFormRevalidate): void => {
  const validationKeys = useMemo(() => {
    if (
      !yupSchemaDynamic ||
      !hasKeys(yupSchemaDynamic) ||
      !dto ||
      !hasKeys(dto)
    ) {
      return "";
    }

    const flattenFields = iterateFormFields(getValues());
    return flattenFields;
  }, [dto, getValues, yupSchemaDynamic]);

  useEffect(() => {
    if (!dto) {
      return;
    }

    if (isEdit && validationKeys.length) {
      clearErrors?.();
      trigger(validationKeys);
    }
  }, [clearErrors, dto, getValues, isEdit, trigger, validationKeys]);
};
